<div class="scroll-container">
    <div class="stat-item" *ngFor="let stat of statsByTemplate">
        <div class="stat-label">{{ stat.templateName }}</div>
        <div class="stat-value">{{ stat.count | number}}</div>
    </div>
</div>